import api, { NewPasswordInput, SignupInput } from '../../data/api.ts';

export const signupMutation = () => ({
    mutationKey: ['signup'],
    meta: { resetQueries: true },
    mutationFn: async (data: SignupInput) => {
        await api.auth.signup(data);
        return null;
    },
});

export const confirmEmailMutation = () => ({
    mutationKey: ['confirmEmail'],
    meta: { resetQueries: true },
    mutationFn: async (token: string) => {
        await api.auth.confirmEmail(token);
        return null;
    },
});

export const confirmInvitationMutation = () => ({
    mutationKey: ['confirmInvitation'],
    meta: { resetQueries: true },
    mutationFn: async ({ token, data }: { token: string; data: NewPasswordInput }) => {
        await api.auth.confirmInvitation(token, data);
        return null;
    },
});

export const loginMutation = () => ({
    mutationKey: ['login'],
    meta: { resetQueries: true },
    mutationFn: async ({
        email,
        password,
        remember = false,
    }: {
        email: string;
        password: string;
        remember: boolean;
    }) => {
        return await api.auth.login({ email, password, remember });
    },
});

export const startSupportSessionMutation = () => ({
    mutationKey: ['startSupportSession'],
    meta: { resetQueries: true },
    mutationFn: async ({ organizationId }: { organizationId: string }) => {
        await api.auth.startSupportSession(organizationId);
        return null;
    },
});

export const endSupportSessionMutation = () => ({
    mutationKey: ['endSupportSession'],
    meta: { resetQueries: true },
    mutationFn: async () => {
        await api.auth.endSupportSession();
        return null;
    },
});

export const logoutMutation = () => ({
    mutationKey: ['logout'],
    meta: { resetQueries: true },
    mutationFn: async () => {
        await api.auth.logout();
        return null;
    },
});

export const forgotPasswordMutation = () => ({
    mutationKey: ['forgotPassword'],
    mutationFn: async (data: { email: string }) => {
        await api.auth.forgotPassword(data);
        return null;
    },
});

export const resetPasswordMutation = () => ({
    mutationKey: ['resetPassword'],
    mutationFn: async ({ token, data }: { token: string; data: NewPasswordInput }) => {
        await api.auth.resetPassword(token, data);
        return null;
    },
});
